var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.511C13 10.095 10.09 13 6.5 13S0 10.095 0 6.511v-.342h.684v.342A5.811 5.811 0 006.5 12.317c3.212 0 5.816-2.6 5.816-5.806A5.812 5.812 0 006.5.704a5.729 5.729 0 00-4.408 2.073l2.377.148-.043.683-2.866-.18-.543-.542L1.197 0l.685.043-.131 2.083A6.392 6.392 0 016.5.021a6.502 6.502 0 016.5 6.49z"
  })));
}
export default SvgRefresh;